import JSolMain from '../JSolMain';

const JSolMainContainer = () => {
  return <JSolMain />;
};

export default JSolMainContainer;
